import tools from '@/sag-core/tools'
import StoreBase from '@/sag-core/base/StoreBase'
import api from './api'
export default function Store(serviceName){
    return tools.mergeDeep(
        new StoreBase(serviceName), {
        state: {
            calendarOptions: [
                {
                    color: 'danger',
                    label: 'task3',
                },
                {
                    color: 'primary',
                    label: 'task1',
                },
                {
                    color: 'warning',
                    label: 'task4',
                },
                {
                    color: 'success',
                    label: 'task2',
                },
                {
                    color: 'info',
                    label: 'task5',
                },
            ],
            selectedCalendars: ['task1', 'task2', 'task3', 'task4', 'task5'],
            events: [],
            dataInterval: {
                WorkObjNo:'',
                Start_Date: '',
                End_Date: ''
            }
        },
        getters: {},
        mutations: {
            SET_SELECTED_EVENTS(state, val) {
                state.selectedCalendars = val
            },
            SET_EVENTS(state,data){
                state.events = data
            },  
            SET_DATAINTERVAL_WORKOBJNO(state, data)
            {
                tools.debug.log({tag: 'eventsStore', title: '設定WORKOBJNO', content: `data: ${data}`}, state)
                state.dataInterval.WorkObjNo = data.value
            },
            SET_DATAINTERVAL_DATE(state, payload) {
                tools.debug.log({tag: 'eventsStore', title: '設定INTERVALDATE', content: `payload: ${payload}`}, state)
                if(state.dataInterval.Start_Date != payload.startStr &&
                    state.dataInterval.End_Date != payload.endStr) 
                {
                    state.dataInterval.Start_Date = payload.startStr.substring(0, 10)
                    state.dataInterval.End_Date = payload.endStr.substring(0, 10)
                }
            },
        },
        actions: {    
            fetchEvents({ commit }, data) {
                tools.debug.log({tag: 'DEBUG', title: '機台行事曆', content: 'fetchEvents'}, data)
                return new Promise((resolve, reject) => {
                    api.apiGetVueMachineCalendar(data).then(response => {
                        commit('SET_EVENTS', response);
                        resolve(response);
                    }).catch(error => {
                        reject(error);
                    });
                });
            },
            addEvent(ctx, { event }) {
                return new Promise((resolve, reject) => {
                    axios
                    .post(`/SAG/${serviceName}/events`, { event })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
                })
            },
            updateEvent(ctx, { event }) {
                return new Promise((resolve, reject) => {
                    axios
                    .post(`/SAG/${serviceName}events/${event.id}`, { event })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
                })
            },
            removeEvent(ctx, { id }) {
                return new Promise((resolve, reject) => {
                    axios
                    .delete(`/SAG/${serviceName}/events/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
                })
            },
        }
    })
}


